import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';

const StudentMutationFormPage = () => {
    const [cost, setCost] = useState(null);
    const [student, setStudent] = useState(null);
    const [branchList, setBranchList] = useState([]);
    const [toBranchId, setToBranchId] = useState('');
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [mutationMonth, setMutationMonth] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/student/mutation/cost')
            .then(response => setCost(response.data.data.cost))
            .catch(error => console.error('Error fetching mutation fee:', error));

        api.get('/utils/getBranchList')
            .then(response => setBranchList(response.data.data.branchList))
            .catch(error => console.error('Error fetching branch list:', error));
    }, []);

    const formatCurrency = (amount) => {
        return parseFloat(amount || 0).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const handleSelectStudent = (selectedStudent) => {
        setStudent(selectedStudent);
        setToBranchId('');
        setShowStudentPopup(false);
    };

    const validateForm = () => {
        const validationErrors = {};

        if (!student) validationErrors.student = 'Student is required';
        if (!toBranchId) validationErrors.toBranchId = 'Destination branch is required';
        if (student && toBranchId && Number(toBranchId) === student.branch_id) {
            validationErrors.toBranchId = 'Destination branch must be different from current branch';
        }
        if (!mutationMonth) validationErrors.mutationMonth = 'Mutation month is required';
        if (!paymentDate) validationErrors.paymentDate = 'Payment date is required';
        if (!paymentMethod) validationErrors.paymentMethod = 'Payment method is required';
        if (!description) validationErrors.description = 'Description is required';
        if (!cost || Number(cost.cost_amount) <= 0) validationErrors.cost = 'Mutation fee must be set in Kidola Price List';

        return validationErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const mutationRequest = {
            data: {
                mutationData: {
                    student_id: student.student_id,
                    to_branch_id: toBranchId,
                    mutation_month: mutationMonth,
                    payment_date: paymentDate,
                    payment_method: paymentMethod,
                    description: description
                }
            }
        };

        api.post('/student/mutation/save', mutationRequest)
            .then(response => {
                navigate('/success', { state: { message: response.data.message } });
            })
            .catch(error => {
                console.error('Error saving student mutation:', error);
                navigate('/error', { state: { message: error.response?.data?.error || 'Please ask to administrator!' } });
            });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Mutation Form</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label>Student Name</label></td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><label>Student Code</label></td>
                                    <td><input type="text" value={student ? student.student_code : ''} readOnly /></td>
                                </tr>
                                <tr>
                                    <td><label>Current Branch</label></td>
                                    <td><input type="text" value={student?.Branch ? student.Branch.branch_name : ''} readOnly /></td>
                                </tr>
                                <tr>{errors.student && <td><div className="error-message">{errors.student}</div></td>}</tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="section">
                    <h3 className="section-header">Mutation Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label>Destination Branch</label></td>
                                    <td>
                                        <select value={toBranchId} onChange={(e) => setToBranchId(e.target.value)}>
                                            <option value="">Choose Destination Branch</option>
                                            {branchList
                                                .filter(branch => !student || branch.branch_id !== student.branch_id)
                                                .map(branch => (
                                                    <option key={branch.branch_id} value={branch.branch_id}>
                                                        {branch.branch_code} - {branch.branch_name}
                                                    </option>
                                                ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>{errors.toBranchId && <td><div className="error-message">{errors.toBranchId}</div></td>}</tr>
                                <tr>
                                    <td><label>Mutation Month</label></td>
                                    <td><input type="month" value={mutationMonth} onChange={(e) => setMutationMonth(e.target.value)} /></td>
                                </tr>
                                <tr>{errors.mutationMonth && <td><div className="error-message">{errors.mutationMonth}</div></td>}</tr>
                                <tr>
                                    <td><label>Mutation Fee</label></td>
                                    <td><input type="text" value={cost ? formatCurrency(cost.cost_amount) : ''} readOnly /></td>
                                </tr>
                                <tr>{errors.cost && <td><div className="error-message">{errors.cost}</div></td>}</tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="section">
                    <h3 className="section-header">Payment Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label>Payment Date</label></td>
                                    <td><input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} /></td>
                                </tr>
                                <tr>{errors.paymentDate && <td><div className="error-message">{errors.paymentDate}</div></td>}</tr>
                                <tr>
                                    <td><label>Payment Method</label></td>
                                    <td>
                                        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                                            <option value="">Choose Payment Method</option>
                                            <option value="BANK BCA">BANK BCA</option>
                                            <option value="BANK BRI">BANK BRI</option>
                                            <option value="CASH">CASH</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>{errors.paymentMethod && <td><div className="error-message">{errors.paymentMethod}</div></td>}</tr>
                                <tr>
                                    <td><label>Description</label></td>
                                    <td><textarea value={description} onChange={(e) => setDescription(e.target.value)} /></td>
                                </tr>
                                <tr>{errors.description && <td><div className="error-message">{errors.description}</div></td>}</tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>

            {showStudentPopup && (
                <StudentListPopup
                    onSelectStudent={handleSelectStudent}
                    onClose={() => setShowStudentPopup(false)}
                />
            )}
        </div>
    );
};

export default StudentMutationFormPage;
